const BASE = "https://www.vaskiontech.com";
const SITE = "Vaskion Technologies Private Limited";
const OG_IMAGE = `${BASE}/assets/vaskion-logo.png`;

export const SEO_PAGES = {
  "/": {
    title: "Vaskion Technologies Private Limited | AI-Powered Software Engineering",
    description:
      "Vaskion Technologies Private Limited designs and builds secure, scalable and future-ready digital solutions — custom software, AI, cloud and enterprise engineering. Innovate • Build • Transform.",
  },
  "/services": {
    title: "Software Development Services | Vaskion Technologies",
    description:
      "Explore Vaskion Technologies' services: custom software development, web and mobile apps, enterprise applications, AI and machine learning, cloud and DevOps, data analytics, IT consulting and more.",
  },
  "/solutions": {
    title: "Digital Solutions | Vaskion Technologies",
    description:
      "AI-powered business solutions, enterprise modernization, cloud transformation, business process automation and secure, scalable digital platforms from Vaskion Technologies.",
  },
  "/technologies": {
    title: "Technologies & Engineering Stack | Vaskion Technologies",
    description:
      "The technologies Vaskion Technologies works with across frontend, backend, mobile, cloud, data and AI to build modern, reliable software.",
  },
  "/industries": {
    title: "Industries We Serve | Vaskion Technologies",
    description:
      "Vaskion Technologies builds digital solutions for organisations across industries, tailoring software to each sector's workflows and compliance needs.",
  },
  "/about": {
    title: "About Us | Vaskion Technologies",
    description:
      "Learn about Vaskion Technologies Private Limited — our mission, values and the way we work to deliver dependable, high-quality software.",
  },
  "/careers": {
    title: "Careers & Job Openings | Vaskion Technologies",
    description:
      "Explore current job openings at Vaskion Technologies Private Limited and apply online. Join a team that values thoughtful engineering and quality.",
  },
  "/contact": {
    title: "Contact Us — Schedule a Consultation | Vaskion Technologies",
    description:
      "Get in touch with Vaskion Technologies Private Limited. Schedule a consultation or send an enquiry about your software project and our team will respond promptly.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Vaskion Technologies",
    description:
      "Read how Vaskion Technologies Private Limited collects, uses and protects the information you share with us.",
  },
  "/terms-of-use": {
    title: "Terms of Use | Vaskion Technologies",
    description:
      "The terms and conditions governing the use of the Vaskion Technologies Private Limited website.",
  },
};

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function applySeo(pathname) {
  const isPrivate = pathname.startsWith("/admin");
  upsertMeta("name", "robots", isPrivate ? "noindex, nofollow" : "index, follow");
  setJsonLd("route-jsonld", null);
  if (isPrivate) return;

  const page = SEO_PAGES[pathname];
  const title = page ? page.title : "Page Not Found | Vaskion Technologies";
  const description = page ? page.description : SEO_PAGES["/"].description;
  const canonical = `${BASE}${pathname === "/" ? "/" : pathname}`;

  document.title = title;
  upsertMeta("name", "description", description);
  upsertLink("canonical", canonical);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:site_name", SITE);
  upsertMeta("property", "og:image", OG_IMAGE);
  upsertMeta("name", "twitter:card", "summary");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", OG_IMAGE);

  if (!page) upsertMeta("name", "robots", "noindex, follow");
}

export const SEO_BASE = BASE;
export const SEO_SITE = SITE;
